<template>
  <b-sidebar
    id="sidebar-verifikasi-dokumen"
    ref="sidebarVerifikasiDokumen"
    title="Verifikasi"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    right
    backdrop
    shadow
    @shown="onShown"
  >
    <div class="px-3 py-2">
      <p>
        <!-- {{localDokumen}} -->
      </p>
      <b-form-group label="Hasil Verifikasi" label-for="verification-status">
        <b-form-select
          v-model="selectedVerificationStatus"
          :options="optionsVerificationStatus"
          class="mb-1"
        />
      </b-form-group>
      <b-form-group label="Keterangan" label-for="keterangan">
        <b-form-textarea
          v-model="catatan"
          placeholder="Tulis Keterangan Disini"
          rows="5"
          trim
        />
      </b-form-group>
      <div class="mb-1">
        &nbsp;&nbsp;.
      </div>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        :disabled="btnSimpanDisabled"
        @click="simpan"
      >
        <b-spinner v-show="btnSimpanSpinnerShow" small type="grow" />
        <span class="sr-only">Loading...</span>
        Simpan
      </b-button>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-warning"
        class="ml-2"
        @click="cancel"
      >
        Batal
      </b-button>
    </div>
  </b-sidebar>
</template>
<script>
import {
  BSidebar,
  BFormGroup,
  BFormTextarea,
  BButton,
  BFormSelect,
  BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import emitter from '@/hap-sia/emitter'
import { getCacheableApi, api } from '@/hap-sia/setup'

export default {
  components: {
    BSidebar,
    // BImg,
    // BForm,
    BFormGroup,
    BFormSelect,
    BFormTextarea,
    BButton,
    BSpinner,
    // BOverlay,
  },
  directives: {
    Ripple,
  },
  props: ['masterDokumen'],
  data() {
    return {
      is_probono: 1,
      layanan_id: null,
      localDokumen: null,
      selectedVerificationStatus: null,
      optionsVerificationStatus: null,
      catatan: null,
      btnSimpanSpinnerShow: false,
      btnSimpanDisabled: false,
    }
  },
  async mounted() {
    emitter.on('VERIFIKASI', async e => {
      this.is_probono = 1
      this.layanan_id = e
      this.$root.$emit('bv::toggle::collapse', 'sidebar-verifikasi-dokumen')
    })
    emitter.on('VERIFIKASI_CLE', async e => {
      this.is_probono = 0
      this.layanan_id = e
      this.$root.$emit('bv::toggle::collapse', 'sidebar-verifikasi-dokumen')
    })
  },
  methods: {
    cancel() {
      this.selectedVerificationStatus = null
      this.$root.$emit('bv::toggle::collapse', 'sidebar-verifikasi-dokumen')
    },
    async simpan() {
      this.btnSimpanSpinnerShow = true
      this.btnSimpanDisabled = true
      // await new Promise(r => setTimeout(r, 2000))
      let result
      try {
        let url
        if (this.is_probono) {
          url = 'probono/verifikasi_layanan'
        } else {
          url = 'cle/verifikasi_layanan'
        }
        result = await api().post(url, {
          id: this.layanan_id,
          verification_status: this.selectedVerificationStatus,
          verification_notes: this.catatan,
        })
      } catch (error) {
        this.makeToast('danger', 'Error', error.response.data.message, true)
        this.btnSimpanSpinnerShow = false
        this.btnSimpanDisabled = false
        return
      }
      emitter.emit('VERIFICATION_UPDATED', result.data)
      this.makeToast('success', 'Sukses', 'Proses Verifikasi berhasil disimpan')
      this.btnSimpanSpinnerShow = false
      this.btnSimpanDisabled = false
      this.selectedVerificationStatus = null
      this.$root.$emit('bv::toggle::collapse', 'sidebar-verifikasi-dokumen')
    },
    async onShown() {
      if (
        !this.optionsVerificationStatus ||
        this.optionsVerificationStatus.length === 1
      ) {
        this.optionsVerificationStatus = [{ value: null, text: 'Loading...' }]
      }
      const cacheApi = await getCacheableApi()
      try {
        const resp = await cacheApi.get('master/status-verifikasi')
        this.optionsVerificationStatus = [
          { value: null, text: '-- Pilih Status Verifikasi --' },
        ]

        resp.data.forEach(element => {
          this.optionsVerificationStatus.push({
            value: element.id,
            text: element.nama,
          })
        })
      } catch (error) {
        alert(error)
        // return
      }
    },
    makeToast(variant = null, title, body, noAutoHide = false) {
      this.$bvToast.toast(body, {
        title,
        variant,
        solid: true,
        autoHideDelay: 5000,
        noAutoHide,
      })
    },
  },
}
</script>
